module.exports = __webpack_public_path__ + "img/key.c81cc646.png";